import { callApi } from '@local_modules/generic/fetch.js'

export async function callScheduleSync (gridApi, entityId) {
  const apiResponse = await callApi('/api/sync-pg/schedule/:accountingOrganisationId', {
    accountingOrganisationId: entityId
  }, { method: 'POST' })

  if (apiResponse.scheduleResponse) {
    const gridRowNode = gridApi.getRowNode(entityId)
    gridRowNode.data.syncStats.nextScheduled = apiResponse.scheduleResponse
  }
}
